import { VoucherInputState, VoucherInputProps } from '../types'

export const deriveVoucherState = (
  voucherState: VoucherInputState,
  prefilledData: VoucherInputProps['prefilledData'],
  voucherCode?: string
) => {
  const isPrefilled = voucherState === VoucherInputState.Prefilled
  const isCheckboxShown = !isPrefilled
  const isCheckboxChecked = voucherState !== VoucherInputState.None
  const isControlsLocked =
    voucherState === VoucherInputState.Prefilled ||
    voucherState === VoucherInputState.Loading ||
    voucherState === VoucherInputState.Valid
  const isSuccessShown =
    (voucherState === VoucherInputState.Valid && !!voucherCode) ||
    (isPrefilled && !!prefilledData?.code)
  const inputValue = (isPrefilled && prefilledData?.code) || voucherCode

  return [
    isCheckboxShown,
    isCheckboxChecked,
    isControlsLocked,
    isSuccessShown,
    inputValue,
  ] as [boolean, boolean, boolean, boolean, string | undefined]
}
